import { AlertCircle, CheckCircle, Clock, Loader2 } from "lucide-react";

export function UploadStatusIcon({ status }: { status: string }) {
  switch (status) {
    case "completed":
      return <CheckCircle className="w-4 h-4 text-green-500" />;
    case "uploading":
      return <Loader2 className="w-4 h-4 text-primary-500 animate-spin" />;
    case "failed":
      return <AlertCircle className="w-4 h-4 text-red-500" />;
    default:
      return <Clock className="w-4 h-4 text-secondary-500" />;
  }
}
